import React from "react"
import { graphql } from "gatsby"

import propTypes from "prop-types"
import { useStaticQuery } from "gatsby"
import ReactDisqusComments from "react-disqus-comments"

import * as S from "./styled"

const Comments = ({ url, title, category }) => {
  const {
    site: {
      siteMetadata: { siteUrl },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const completeURL = `${siteUrl}${url}`

  return (
    <S.CommentsWrapper>
      <ReactDisqusComments
        shortname="evolve-std"
        identifier={completeURL}
        title={title}
        url={completeURL}
      />
    </S.CommentsWrapper>
  )
}

Comments.propTypes = {
  url: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
}

export default Comments
